<template>
    <div id="About" class="page" >
        <appModal ref="appModalRef" :countries="DBCountries"></appModal>
        <appHeader bgColor="blue" @headerMenuClicked="menuClicked" page="about"></appHeader>
        <div class="main">
            <div class="main_inner">
                <section class="main_section">
                    <div class="section_content">
                        <h2 class="text_subtitle">More</h2>
                        <h1 class="title_page text_title2">
                            About
                        </h1>
                        <p class="text_p" style="margin-top: 24px;">
                            The Atlas of the Offshore World is a global database aimed at informing scientific communities, civil society, and policymakers around the world about global tax avoidance. It provides detailed and accessible information about global profit shifting, offshore financial and real estate wealth, and effective tax rates worldwide, in order to facilitate and promote democratic dialogue on these topics. The Atlas of the Offshore World is produced by the <a href="https://www.taxobservatory.eu/" target="_blank">EU Tax Observatory</a> in collaboration with <a href="https://www.skatteforsk.no/" target="_blank">Skatteforsk - Centre for Tax Research</a> and with financial support from <a href="https://resultater.norad.no/agreement/QZA-22/0011" target="_blank">Norway</a>.
                        </p>
                    </div>
                </section>

                <section class="main_section section_about">
                    <div class="section_content">
                        <div class="content_title">Our Team</div>
                        <div class="content_team">
                            
                            <div class="content_team_member" v-for="(memberObj, memberIndex) in DBTeam">
                                <div class="member_snapshot member_wrapper" @click="showBio(memberObj)" v-if="!memberObj.toggleBio">
                                    <div class="member_image">
                                        <img :src="'/images/members/'+slugifyText(memberObj.name)+'.png'" />
                                    </div>
                                    <div class="member_content">
                                        <div class="member_name">{{memberObj.name}}</div>
                                        <div class="member_job">{{memberObj.job}}</div>
                                    </div>
                                    <div class="snapshot_hover">
                                        <div class="hover_text">Click to read description</div>
                                    </div>
                                </div>
                                <div class="member_bio member_wrapper" v-else>
                                    <div class="bio_closebt" @click="hideBio()">Close</div>
                                    <div class="bio_text">
                                        {{memberObj.bio}}
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </section>

                <section class="main_section section_about section_funders">
                    <div class="section_content">
                        <div class="content_title">Our Funders</div>
                        <div class="content_col col_first">
                            <div class="partner_block small">
                                <a href="https://resultater.norad.no/en" target="_blank" class="block_head"></a>
                            </div>
                        </div>
                        <div class="content_col col_second">
                            <div class="partner_block small">
                                <a href="https://european-union.europa.eu/index_en" target="_blank" class="block_head"></a>
                            </div>
                        </div>
                        <div class="content_text">
                            Co-funded by the European Union and Norway. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union and Norway. Neither the European Union nor Norway can be held responsible for them.
                        </div>
                    </div>
                </section>

                <section class="main_section section_about section_partners">
                    <div class="section_content">
                        <div class="content_title">Our Partners</div>
                        <div class="content_col col_first">
                            <div class="partner_block small">
                                <a href="https://www.nmbu.no/forskning/grupper/skatteforsk" target="_blank" class="block_head"></a>
                            </div>
                        </div>
                        <div class="content_col col_second">
                            <div class="partner_block small">
                                <a href="https://www.diw.de/en" target="_blank" class="block_head"></a>
                            </div>
                        </div>
                    </div>
                </section>
            </div> 
        </div>
        <appFooter></appFooter>
        <cookiesConsent></cookiesConsent>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'
    import cookiesConsent from '~/components/cookiesConsent.vue'

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal,
            "cookiesConsent": cookiesConsent
        },

        data: function () {
            return {
                isDataLoaded: false,
                DBCountries: [],
                DBTeam: [
                    {
                        name: "Annette Alstadsæter",
                        job: "Director, Skatteforsk - Centre for Tax Research",
                        toggleBio: false,
                        bio: "Annette Alstadsæter is Professor at School of Economics and Business, Norwegian University of Life Sciences, and head of SKATTEFORSK – Center for Tax Research. Her research is on tax evasion, tax avoidance, and inequality, and she has published in top academic journals in addition to being highly involved in the public debate and policy work. She is columnist in DN and member of both the Norwegian and Swedish Fiscal Policy Councils."
                    },
                    {
                        name: "Pierre Bachas",
                        job: "Dataset coordinator: Effective tax rates on capital and labor",
                        toggleBio: false,
                        bio: "Pierre is an Assistant Professor of Finance at the ESSEC-Business School, on leave from the World Bank Development Research Group (DECRG). He received a PhD in Economics from UC Berkeley in 2016. His research focuses on the welfare impacts of taxes and subsidies in context with widespread informality, and the distinct challenges developing countries face to collect tax revenue."
                    },
                    {
                        name: "Inga Chilashvili",
                        job: "Communication officer, EU Tax Observatory",
                        toggleBio: false,
                        bio: "Inga Chilashvili joined the EU Tax Observatory as a Communications Officer in February 2024. She is responsible for organizing public events, managing social media, and creating content. Inga has eight years of experience in the communications field, having worked for the EIF Secretariat at the World Trade Organization, the Border Police of Georgia, and the National Defence Academy of the Ministry of Defence of Georgia. She holds an advanced MA in European Interdisciplinary Studies from the College of Europe and an MSc in Marketing Communications and Public Relations from the University of Chester."
                    },
                    {
                        name: "Matthew Collin",
                        job: "Senior economist, EU Tax Observatory",
                        toggleBio: false,
                        bio: "Matt Collin is a Senior Researcher at the EU Tax Observatory, where he conducts empirical research on illicit financial flows (cross-border tax evasion, money-laundering, and related activity). He was previously an Economist in the World Bank’s Global Tax Team, a Rubenstein Fellow at the Brookings Institution, and a Research Fellow at the Center for Global Development. He earned his DPhil (PhD) in Economics at the University of Oxford in 2013. His published work includes publications in the Journal of Development Economics and Economic Development and Cultural Change."
                    },
                    {
                        name: "Lauren Debussy",
                        job: "Administrative assistant, EU Tax Observatory",
                        toggleBio: false,
                        bio: "Lauren Debussy is the EU Tax Observatory’s Administrative Assistant. She is in charge of ensuring that everything runs as smoothly as possible in our day-to-day operations. Lauren has more than 10 years of experience in education and support roles in the United States, Japan, and now in France. With a degree in Music and certificates in TESOL, Japanese, and French, she brings a curious mind and ready smile to our team"
                    },
                    {
                        name: "Idann Gidron",
                        job: "Dataset coordinator: Profit shifting by multinational enterprises",
                        toggleBio: false,
                        bio: "Idann Gidron is a data coordinator at the EU Tax Observatory. He has previously worked at the OECD in the Business and International Tax unit, where he was responsible for the calculation of forward-looking corporate effective tax rates, among other projects. Idann holds a master’s degree in policy economics from Erasmus University Rotterdam. His master’s thesis develops a new tax policy indicator that captures the joint impact of corporate and environmental taxes on business investment incentives."
                    },
                    {
                        name: "Sarah Godar",
                        job: "Dataset coordinator: Offshore financial wealth",
                        toggleBio: false,
                        bio: "Sarah Godar is a researcher at the EU Tax Observatory, based at the DIW Berlin. Her research focuses on international tax avoidance, tax competition and offshore financial wealth. She is part of the team behind the Atlas of the Offshore World in her role as data coordinator of the offshore financial wealth dataset. She holds a Ph.D. from the Institute of Economic Studies, Charles University in Prague."
                    },
                    {
                        name: "Noé Mendoza",
                        job: "Dissemination advisor, Skatteforsk - Centre for Tax Research",
                        toggleBio: false,
                        bio: "Noé Mendoza is dissemination advisor at Skatteforsk - Centre for Tax Research. He is PhD candidate in International Environment and Development Studies at the Norwegian University of Life Sciences. He has carried out research on local institutions in rural and indigenous contexts in Southeastern Mexico. Noé is broadly interested in promoting transformative ideas of social transformation."
                    },
                    {
                        name: "Karan Mishra",
                        job: "Research Assistant",
                        toggleBio: false,
                        bio: "Karan Mishra works as a Junior Reseracher at the EU Tax Observatory. He holds a master’s degree from Paris School of Economics and was a research assistant at the CNRS. He is broadly interested in the questions at the intersection of public economics, political economy, and macroeconomics."
                    },
                    {
                        name: "Carolina Moura",
                        job: "Research assistant, EU Tax Observatory",
                        toggleBio: false,
                        bio: "Carolina (Moniz De) Moura works as a research assistant at the EU Tax Observatory. She holds a Master’s degree in Analysis and Policy in Economics from the Paris School of Economics. Previously, Carolina worked as a research assistant at the Climate Policy Initiative and Stanford University. Her primary research interests lie in the fields of public economics and environmental economics."
                    },
                    {
                        name: "Andreas Økland",
                        job: "Dataset coordinator: Offshore real estate",
                        toggleBio: false,
                        bio: "Andreas Økland is a Postdoctoral at Norwegian University of Life Sciences (NMBU). He is the real estate data coordinator for the EU Tax Observatory project Atlas of the Offshore World (atlas-offshore.world). He is also responsible for administrative data coordinator at Skatteforsk – Centre for Tax Research. He earned his PhD in Economics in 2022 and his research focus on tax evasion and global investment patterns, with recent focus on offshore real estate and cryptocurrency."
                    },
                    {
                        name: "Lamia Oualalou",
                        job: "General manager, EU Tax Observatory",
                        toggleBio: false,
                        bio: "Lamia Oualalou is the General Manager of the EU Tax Observatory. Passionate about social justice, she spent over five years at ICRICT, a commission on tax reform led by Joseph Stiglitz and Jayati Ghosh. She managed media relations for IFC (World Bank) in Europe, gaining experience in international organizations. A former journalist, correspondent, and editor, she reported for Le Figaro, Mediapart, and Le Monde Diplomatique. After years in Rabat, São Paulo, Rio, Mexico City, London, and Paris, she defines herself as a citizen of the world."
                    },
                    {
                        name: "Quentin Parrinello",
                        job: "Policy director, EU Tax Observatory",
                        toggleBio: false,
                        bio: "Quentin Parrinello is a Policy Director at the EU Tax Observatory. He is responsible for promoting the work of the Observatory with policymakers, the media, and other stakeholders as well as building policy recommendations. Quentin has extensive experience working on tax policy campaigns. In 2020, he was appointed among the 35 leaders of the future on taxation by TaxCoop."
                    },
                    {
                        name: "Carlos Salgado",
                        job: "Research assistant, EU Tax Observatory",
                        toggleBio: false,
                        bio: "Carlos Salgado is a Research Assistant at the EU Tax Observatory. He holds a Master’s degree in Development Economics from Université Paris 1 Panthéon-Sorbonne. Carlos previously worked as a Consultant for the United Nations Development Programme (UNDP) in Honduras and as a Research Assistant for the CNRS at the Paris School of Economics. He is mainly interested in political economy and development."
                    },
                    {
                        name: "Hector Ulloa",
                        job: "Outreach director, Skatteforsk - Centre for Tax Research",
                        toggleBio: false,
                        bio: "Hector is Outreach Director at Skatteforsk - Centre for Tax Research. He has an academic background in law with a Master's in public administration. He served as president of the Norwegian Students' and Academics' International Assistance Fund (2021-2023) where he worked on topics related to the right to education, human rights and inequality. Currently he also serves as board member of Debt Justice Norway (SLUG) and is an Executive Committee member of the UN's Education Cannot Wait fund."
                    },
                    {
                        name: "Gabriel Zucman",
                        job: "Director, EU Tax Observatory",
                        toggleBio: false,
                        bio: "Gabriel Zucman is the director of the EU Tax Observatory. He is the author of articles published in peer-reviewed journals such as the Quarterly Journal of Economics, the American Economic Review, the Journal of Public Economics, and of two books. His research focuses on the accumulation, distribution, and taxation of global wealth and has renewed the analysis of the macro-distributional implications of globalization."
                    }
                ],
                sortedTeam: []
            }
        },

        created: function () {

        },

        mounted: function () {
            var self = this; 
                        this.loadCountriesMetadata();
        },

        methods: {
            loadCountriesMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData().then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                }).catch(err => {
                console.log(err);
              });
            },

            showBio: function (memberObj){
                _.each(this.DBTeam, function (o){
                    o.toggleBio = false;
                })
                memberObj.toggleBio = true;
            },

            hideBio: function (){
                _.each(this.DBTeam, function (teamObj){
                    teamObj.toggleBio = false;
                })
                document.activeElement.blur()

            },

            truncate(text) {
              return `${text.substring(0, this.briefTextLimit)}...`;
            },

            slugifyText(text){
                return slugify(text)
            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },
        },

        watch: {

        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #About .main{
        background: #fff;
        .main_section{
            &.section_funders{
                height: 320px;
            }
            &.section_partners{
                height: 340px;
            }
            &.section_funders, &.section_partners{
                .block_head{
                    cursor: pointer;
                }
            }
             &.section_about{
                padding: 50px 0 60px;
                background: linear-gradient(180deg, #EEF1F6 0%, rgba(238, 241, 246, 0.00) 100%);
                .content_title{
                    font-size: 32px;
                    color: $colorBlue;
                    letter-spacing: 3.2px;
                    font-weight: 400;
                    border-top: 4px solid $colorBlue;
                    padding-top: 10px;
                }

                .content_text{
                    margin-top: 10px;
                }
                    
                .content_team{
                    margin-top: 20px;
                    text-align: center;
                    display: inline-flex;
                    flex-wrap: wrap;
                    gap: 16px;
                    justify-content: left;
                }
                .content_team_member{
                    width: 296px;
                    height: 372px;
                    position: relative;
                    background: #E6E9F0;
                    .member_wrapper{
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 100%;
                        height: 100%;
                        &.member_snapshot{
                            cursor: pointer;
                        }
                        &.member_bio{
                            padding: 32px;
                            background: #164193;
                            text-align: left;
                            .bio_closebt{
                                position: relative;
                                cursor: pointer;
                                font-size: 16px;
                                letter-spacing: 1.2px;
                                color: #fff;
                                display: inline-block;
                                &:after{
                                    content: "";
                                    position: absolute;
                                    left: 100%;
                                    top: 50%;
                                    background: url("/images/close.svg") no-repeat 0 0;
                                    background-size: 100% 100%;
                                    width: 20px;
                                    height: 20px;
                                    transform: translate(0, -50%);
                                    margin-left: 4px;
                                }
                            }
                            .bio_text{
                                font-size: 12px;
                                font-weight: 700;
                                line-height: 18px;
                                position: absolute;
                                left: 32px;
                                right: 32px;
                                top: 60px;
                                bottom: 32px;
                                overflow: auto;
                                color: #fff;
                            }
                        }
                        .snapshot_hover{
                            display: none;
                            position: absolute;
                            left: 0px;
                            top: 0px;
                            width: 100%;
                            height: 100%;
                            background: rgba(22, 65, 147, .6);
                            .hover_text{
                                color: #fff;
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                transform: translate(-50%, -50%);
                                font-size: 16px;
                                letter-spacing: 1.2px;
                            }
                        }
                        &:hover{
                            .snapshot_hover{
                                display: block;
                            }
                        }
                    }
                    .member_image{
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 100%;
                        height: 240px;
                        overflow: hidden;
                        img{
                            width: 100%;
                        }
                    }
                    .member_content{
                        position: relative;
                        margin-top: 240px;
                        text-align: left;
                        padding: 20px;
                        .member_name{
                            color: $colorBlue;
                            font-size: 24px;
                            font-weight: 700;
                            line-height: 28px;
                        }
                        .member_job{
                            color: $colorBlue;
                            font-size: 16px;
                            margin-top: 5px;
                            font-weight: 700;
                            text-transform: uppercase;
                        }
                    }
                }
            }
        }
    }

   
</style>


// WEBPACK FOOTER //
// pages/about/index.vue